import { RefreshCw } from 'lucide-react'
import { cn } from '../../lib/utils'

interface PullToRefreshIndicatorProps {
  pullDistance: number
  isRefreshing: boolean
  threshold?: number
}

export function PullToRefreshIndicator({
  pullDistance,
  isRefreshing,
  threshold = 80
}: PullToRefreshIndicatorProps) {
  const progress = Math.min((pullDistance / threshold) * 100, 100)
  const rotation = (pullDistance / threshold) * 360

  if (pullDistance === 0 && !isRefreshing) return null

  return (
    <div
      className="fixed top-0 left-0 right-0 flex items-center justify-center z-50 pointer-events-none"
      style={{
        transform: `translateY(${Math.min(pullDistance, threshold + 20)}px)`,
        transition: isRefreshing ? 'transform 0.3s ease-out' : 'none'
      }}
    >
      <div className={cn(
        "bg-white rounded-full shadow-lg p-3 border-2 border-blue-100",
        isRefreshing && "animate-pulse"
      )}>
        <RefreshCw
          className={cn(
            "h-6 w-6 text-blue-500 transition-transform",
            isRefreshing && "animate-spin"
          )}
          style={{
            transform: isRefreshing ? 'rotate(0deg)' : `rotate(${rotation}deg)`,
            transition: isRefreshing ? 'none' : 'transform 0.1s linear'
          }}
        />
      </div>

      {/* Progress text */}
      {!isRefreshing && (
        <div className="absolute top-full mt-2 text-sm text-gray-600 font-medium">
          {progress >= 100 ? 'Release to refresh' : 'Pull to refresh'}
        </div>
      )}
    </div>
  )
}
